import React from 'react';
import { courses } from './plans';
import '../styles/priceTableAll.css';

const PriceTableAll = () => {
  const renderTableRows = () => {
    const rows = [];
    
    Object.entries(courses).forEach(([courseKey, courseData]) => {
      const { name: courseName, plans, available } = courseData;

      plans.forEach((plan, index) => {
        rows.push(
          <tr key={`${courseKey}-${index}`}>
            {index === 0 && (
              <>
                <td rowSpan={plans.length} className="course-name">
                  {courseName}
                </td>
              </>
            )}
            <td>{plan.title}</td>
            <td className="text-center">{plan.monthly ? '月額' : '一括'}</td>
            <td className="text-right">
              {plan.monthly ? `月額 ${plan.price} 円` : `総額 ${plan.price} 円`}
            </td>
            <td className="text-right">{plan.minLessons ? `${plan.minLessons} レッスン` : ''}</td>
            {index === 0 && (
              <td rowSpan={plans.length} className="available-cell">
                {available}
              </td>
            )}
            <td className="text-center">{plan.makeupLessons}</td>
            <td className="text-center">{plan.period}</td>
            {/* ここで、plan.consultantが空欄の場合はハイフンを表示 */}
            <td className="text-center">{plan.consultant ? plan.consultant : '-'}</td>
            <td className="feature-cell">{plan.feature}</td>
          </tr>
        );
      });
    });

    return rows;
  };

  return (
    <div className="elt-wp-plugin  table-responsive">
      <table className="price-table">
        <thead>
          <tr>
            <th className="course-name-header">コース名</th>
            <th>プラン名</th>
            <th>お支払方法</th>
            <th>金額</th>
            <th>最小レッスン数</th>
            <th>受講例</th>
            <th>振替回数</th>
            <th>有効期間</th>
            <th>専属担当者</th>
            <th>特徴</th>
          </tr>
        </thead>
        <tbody>{renderTableRows()}</tbody>
      </table>
    </div>
  );
};

export default PriceTableAll;

